import { Navigate, useLocation } from "react-router-dom";
import {useContext} from "react";
import UserContext from "../context/UserContext";

export const AuthenticatedRoute = ({ children }:any) => {
  const context = useContext(UserContext);
  const location = useLocation();
  const isAuthenticated = context.authentication.authenticated;
  const isAuthroized = context?.authentication?.session?.role[0]?.authority &&["ROLE_ADMIN:EDIT", "ROLE_ADMIN:VIEW", "ROLE_OPERATOR:EDIT", "ROLE_OPERATOR:VIEW", "ROLE_BLOGGER:VIEW", "ROLE_BLOGGER:EDIT"].includes(context?.authentication?.session.role[0].authority)
    
  if (!isAuthenticated || !isAuthroized) {
    // Save current location and redirect to login with returnUrl
    return <Navigate to={`/login?returnUrl=${encodeURIComponent(location.pathname + location.search)}`} />
  }
  return children;
};